import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteInactivePageService {
  private readonly domains = [
    'messenger.skebby.com',
    'messenger.skebby.it',
    'app.smsenvoi.com',
    'app.smsenvoi.fr',
    'trend.esendex.it',
    'localhost:4200'
  ];

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (state.url === '/register') {
      return this.isSkipRegisterPageByBrand();
    } else {
      return true;
    }
  }

  private isSkipRegisterPageByBrand(): Observable<boolean> | boolean {
    const domainRegisterPage = window.location.host;
    console.log('host:', domainRegisterPage);
    return this.routeToLoginByBrand(domainRegisterPage);
  }

  private routeToLoginByBrand(domains) {
    if (!this.domains.includes(domains)) {
      this.router.navigate(['']);
      return false;
    }
    return true;
  }
}
